import {
    Button,
    Checkbox,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControl,
    FormControlLabel,
    InputLabel,
    MenuItem,
    Select,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import axios from "axios";
import * as React from "react";

import { Config } from "../../../config/config";
import { getGlobalVar, Helpers } from "../../../utils/helpers";
import { PopupMessage } from "../../../utils/message";

interface State {
    saving: boolean;
    showModal: boolean;
    selected: any[];
    difficulty: string;
    type: "RANKED" | "RUBY_BATTLE"
}

interface Props {
    playerId: string;
    activeEnv: any;
    heroesConfig: any;
    classes?: any;
    form?: any;
    playerData: any;
    refreshData(): void;
}

export class AddPlayerDailyJob extends React.Component<Props, State> {

    constructor(props) {
        super(props);

        this.state = {
            saving: false,
            showModal: false,
            selected: [],
            difficulty: "easy",
            type: "RANKED",
        };
    }

    showDialog = () => {
        this.setState({
            showModal: true,
        });
    }

    onDialogClose = () => {
        this.setState({
            showModal: false,
        });
    }

    onContractAdd = () => {
        this.setState({ saving: true }, async () => {
            try {
                const dailyType = this.state.type === "RUBY_BATTLE" ? "ruby" : "ranked";
                await axios.post(`${Config.getInstance.apiUrl}/api/user/${this.props.playerId}/achievements/${dailyType}`, {
                    type: "contracts",
                    items: this.state.selected,
                }, {
                    headers: {
                        Authorization: Helpers.getSessionId(),
                        env: this.props.activeEnv,
                    },
                });

                this.setState({
                    selected: [],
                    saving: false,
                    showModal: false,
                }, () => {
                    this.props.refreshData();
                });
            } catch (error) {
                PopupMessage.error("Something went wrong");

                this.setState({
                    selected: [],
                    saving: false,
                    showModal: false,
                });
            }
        });
    }

    handleChange = (event) => {
        const { value, checked } = event.target;

        this.setState(prevState => ({
            ...(checked && {
                selected: [...prevState.selected, {
                    key: value,
                    difficulty: this.state.difficulty,
                    hqLevel: this.props.playerData?.headquarter_level || 0,
                }],
            }),
            ...(!checked && {
                selected: prevState.selected.filter(item => item.key !== value),
            }),
        }));
    }

    onDifficultyChange = (event) => {
        const { value } = event.target;

        this.setState({ difficulty: value, selected: [] });
    }
    onTypeChange = (event) => {
        const { value } = event.target;
        this.setState({ type: value, selected: [] });
    }

    getJobLocalizationKey = (key, difficulty, type: "title" | "description") => {
        // const dailyJobLocalization = getGlobalVar("DAILY_JOBS").localization[`${key}_${difficulty.toLowerCase()}`];
        return Helpers.getLocalizationName(`DJOB_TITLE_${key}`);
    }

    getItems = () => getGlobalVar("DAILY_JOBS").dailyJobs.filter(job =>
        job.hqLevel === (this.props.playerData?.headquarter_level || 0) &&
        job.difficulty === this.state.difficulty && job.type === this.state.type,
    )

    render() {
        return <React.Fragment>
            <Button disableElevation variant="contained" onClick={this.showDialog} color="primary">
                <AddIcon/> Add daily quests
            </Button>

            <Dialog
                open={this.state.showModal}
                onClose={this.onDialogClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                fullWidth={true}
                maxWidth="sm"
            >
                <DialogTitle id="alert-dialog-title">Add daily quest</DialogTitle>
                <DialogContent>
                    <React.Fragment>
                        <span>
                            <FormControl style={{ marginBottom: 20 }}>
                                <InputLabel id="daily-type-select-label">Type</InputLabel>
                                <Select
                                    labelId="daily-type-select-label"
                                    value={this.state.type}
                                    onChange={this.onTypeChange}
                                >
                                    <MenuItem value="RANKED">Ranked</MenuItem>
                                    <MenuItem value="RUBY_BATTLE">Ruby</MenuItem>
                                </Select>
                            </FormControl>
                            <FormControl style={{ marginBottom: 20 }}>
                            <InputLabel id="difficulty-select-label">Difficulty</InputLabel>
                            <Select
                                labelId="difficulty-select-label"
                                value={this.state.difficulty}
                                onChange={this.onDifficultyChange}
                            >
                                <MenuItem value="easy">Easy</MenuItem>
                                <MenuItem value="medium">Medium</MenuItem>
                                <MenuItem value="hard">Hard</MenuItem>
                            </Select>
                        </FormControl>
                        </span>

                        {this.getItems().map(job => (
                            <FormControlLabel
                                key={job.key}
                                style={{ float: "left", width: "100%", marginBottom: 15 }}
                                control={<Checkbox value={job.key} key={`${job.key}_${this.state.difficulty}`} onChange={this.handleChange}/>}
                                label={<div>
                                    <span style={{ float: "left" }}>
                                        <b>[{job.key}] {this.getJobLocalizationKey(job.key, job.difficulty, "title")}</b>
                                    </span>
                                    <span style={{ float: "left", clear: "both" }}>
                                        {this.getJobLocalizationKey(job.key, job.difficulty, "description").replace("{0}", job.goal)}
                                    </span>
                                </div>}
                            />
                        ))}
                    </React.Fragment>
                </DialogContent>
                <DialogActions>
                    <Button disableElevation onClick={this.onDialogClose}>
                        Cancel
                    </Button>

                    <div className="loading--button-wrapper">
                        <Button disableElevation onClick={this.onContractAdd} color="primary" disabled={this.state.saving}>
                            Add
                        </Button>

                        {this.state.saving && <CircularProgress size={24} className="loading--button-progress"/>}
                    </div>
                </DialogActions>
            </Dialog>
        </React.Fragment>;
    }
}
